export const DelayMillisecondsToHideNewsletterWidget = 3000;
